// extracted by mini-css-extract-plugin
module.exports = {"mbLogo":"LoginConsumer_mbLogo__2B6BD","mbLineBreak":"LoginConsumer_mbLineBreak__3TyrQ"};